<app-questionnaire-summary [appScrollIntoView]="true" hideTitle="true">
  <app-summary-row label="Type of cover">
    <span *ngIf="coverBasis === 'LEVEL'">
      Level Term Family Cover
    </span>
    <span *ngIf="coverBasis === 'DECREASING'">
      Decreasing Term Mortgage Cover
    </span>
  </app-summary-row>

  <app-summary-row label="Term">{{term}} years</app-summary-row>
  <app-summary-row label="Sum Assured">{{sumAssured | pounds}}</app-summary-row>
  <app-summary-row label="Type of policy">
    {{singleOrDual === 'SINGLE' ? 'Just me': 'For you and your partner'}}
  </app-summary-row>
</app-questionnaire-summary>

<div class="premium">
  <span>{{quote.result?.premium | pounds}}</span>
  <small>{{quote.result?.premium | appcents}}/month</small>
</div>

<label class="valid-until">
  Quote valid until: {{quote.result.validUntil | date:'dd/MM/yyyy'}}
</label>
